import HomePage from '../home'

const SearchPage = () => {
  return (
    <HomePage />
  )
}

export default SearchPage
